export default function CTAAppel() {
  return (
    <section className="bg-brand-blue py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
          Coffre endommagé ? Intervention rapide à Strasbourg
        </h2>
        <p className="text-white/80 text-base md:text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
          Nos techniciens se déplacent dans tout le Bas-Rhin pour réparer ou remplacer votre coffre de volet roulant. Devis gratuit, pièces en stock.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4 justify-center">
          <a
            href="tel:0374473240"
            className="flex items-center justify-center gap-2 bg-brand-cyan text-white px-8 py-4 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap w-full sm:w-auto sm:min-w-[260px]"
          >
            <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
            Appeler le 03 74 47 32 40
          </a>
          <a
            href="#devis"
            className="inline-flex items-center justify-center gap-2 bg-white text-brand-blue px-8 py-4 rounded-full font-semibold text-base hover:bg-white/90 transition-all duration-200 btn-hover-effect border border-white/30 whitespace-nowrap w-full sm:w-auto sm:min-w-[260px]"
          >
            <span className="btn-icon-wrap"><i className="ri-file-list-3-line text-lg"></i></span>
            Devis gratuit
          </a>
        </div>
      </div>
    </section>
  );
}